import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "scroll-container"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 1,
  class: "scroll-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericTabs = _resolveComponent("GenericTabs")!
  const _component_GearButton = _resolveComponent("GearButton")!
  const _component_InventoryItem = _resolveComponent("InventoryItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_GenericTabs, {
      tabs: _ctx.tabs,
      variant: "contained",
      "max-width": "60%",
      onActiveTab: _ctx.handleActiveTab
    }, null, 8, ["tabs", "onActiveTab"]),
    (_ctx.activeTab === 'BASIC')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.items), (itemKey, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "single-gear-item",
                key: _ctx.items[itemKey].name
              }, [
                _createVNode(_component_GearButton, {
                  item: _ctx.items[itemKey],
                  "gear-slot": _ctx.gearSlot,
                  "item-index": i,
                  onResetView: _ctx.resetView
                }, null, 8, ["item", "gear-slot", "item-index", "onResetView"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 'CRAFTED')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.inventory[_ctx.gearSlot], (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_InventoryItem, {
                item: item,
                "item-index": index,
                onResetView: _ctx.resetView
              }, null, 8, ["item", "item-index", "onResetView"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
  ], 64))
}